import { invokeOrFalse, invokeOrIdentity } from 'src/utils';
import Vue from 'vue';
export default Vue.extend({
    props: {
        menuItems: { type: Array, required: true },
        objectProp: { type: Object },
        activateWithLeftClick: { type: Boolean },
        qMenuPropsProp: { type: Object }
    },
    computed: {
        menuItems_computed() {
            return this.menuItems.map(item => {
                return Object.assign(Object.assign({}, item), { icon: invokeOrIdentity(item.icon, this.objectProp), label: invokeOrIdentity(item.label, this.objectProp), htmlLabel: invokeOrIdentity(item.htmlLabel, this.objectProp), infoTip: invokeOrIdentity(item.infoTip, this.objectProp), disabled: invokeOrIdentity(item.disabled, this.objectProp), componentProps: invokeOrFalse(item.componentProps, this.objectProp) });
            });
        },
        qMenuProps() {
            return Object.assign({ contextMenu: !this.activateWithLeftClick, autoClose: true, contentClass: 'context-menu' }, this.qMenuPropsProp);
        }
    },
    methods: {
        itemIsDisabled(item) {
            if (item.disabled === undefined) {
                return false;
            }
            else if (typeof item.disabled === 'function') {
                return item.disabled(this.objectProp);
            }
            else {
                return item.disabled;
            }
        },
        handleClick(e, item) {
            if (typeof item.clickHandler === 'function') {
                item.clickHandler({ row: this.objectProp, col: {} }, {}, e);
            }
        }
    }
});
